import type { CollectionCodeDataItem, CompositePrimaryKey, ResolvedMonospaceCollection, ResolvedMonospacePrimitiveField, ResolvedMonospaceSingleRelationField } from '#layers/data-model/public';
import { createBlockRootContextProperty } from '#layers/block-engine/public';

export interface FormBlockRootContext {
	collection?: ResolvedMonospaceCollection;
	fields?: Array<ResolvedMonospacePrimitiveField | ResolvedMonospaceSingleRelationField>;
	currentItemId?: CompositePrimaryKey | null;
	currentValues?: CollectionCodeDataItem;
}

const formBlockRootContext = createBlockRootContextProperty<FormBlockRootContext>('form');

export const exposeFormToBlockRootContext = formBlockRootContext.expose;
export const consumeFormBlockRootContext = formBlockRootContext.consume;
